import React from 'react';
import { Mutation, Query } from 'react-apollo';
import { ADVERTISE_SMS_LOGIN, REJECT_SMS_LOGIN } from '../../graphql';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { isToggleActive } from '../../components/featureToggle/toggles';
import { withRouter } from 'react-router-dom';
import Modal from 'styled-react-modal';
import { useState } from 'react';
import { ActivateSmsLoginFeature, LoginSmsFeatureActivated } from '../smsLogin/ActivateSmsLoginFeature';
import gql from 'graphql-tag';

const Container = styled(Flex)`
  width: 100%;

  @media screen and (max-width: 480px) {
    width: 100vw;
    max-width: 100vw;
    padding: 0 20px;
  }
`;
const GENERATE_CODE = gql`
  mutation getSmsLoginActivationOtp {
    getSmsLoginActivationOtp {
      ok
      reason
    }
  }
`;
const convertErrorCodeToString = (errorCode) => {
  if (!errorCode) return 'An error occured';

  switch (errorCode) {
    case 'ALREADY_ACTIVE':
      return 'The feature is already active on your account';
    case 'ALREADY_SENT':
      return 'A code has already been sent to you recently';
    case 'ATTEMPTS_BLOCKED':
      return 'Attempts blocked for 24 hours';
    case 'INVALID':
      return 'Incorrect code';
    case 'CODE_TOO_OLD':
      return 'Code expired';
    default:
      return 'An error occured';
  }
};

export const AdvertiseSmsLogin = withRouter(({ history }) => {
  const [isActivateMode, setIsActivateMode] = useState(false);
  const [errors, setErrors] = useState(null);
  const toggle = isToggleActive('SMS_LOGIN');
  const initTok = localStorage.getItem('initialToken');
  const [currentStep, setCurrentStep] = useState();
  const [showComplete, setShowComplete] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  if (!toggle || (initTok && initTok !== '')) return null;
  if (!!showComplete) {
    return (
      <Modal
        isOpen={showComplete}
        onBackgroundClick={() => {
          setShowComplete(false);
        }}
        onEscapeKeydown={() => {
          setShowComplete(false);
        }}
      >
        {/* <SpecialModalBackground> */}
        <Box
          style={{
            margin: '0 auto',
            alignSelf: 'center',
            borderRadius: '20px',
            position: 'relative',
            backgroundColor: 'white',
            padding: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100vw',
            maxWidth: '650px',
          }}
        >
          <Flex flexDirection={'column'} mt={4}>
            <LoginSmsFeatureActivated onClose={() => setShowComplete(false)} />
          </Flex>
        </Box>
        {/* </SpecialModalBackground> */}
      </Modal>
    );
  }
  return (
    <Mutation refetchQueries={[{ query: ADVERTISE_SMS_LOGIN }]} awaitRefetchQueries={true} mutation={REJECT_SMS_LOGIN}>
      {(mutateReject, { loading: loadingReject }) => (
        <Query query={ADVERTISE_SMS_LOGIN}>
          {({ data, loading }) => {
            if (!!loading || !data || data.getShouldAdvertiseSmsLogin === 1 || data.getShouldAdvertiseSmsLogin === 2) return null;

            return (
              <Modal
                isOpen={isOpen}
                onBackgroundClick={() => {
                  if (!loadingReject) {
                    mutateReject();
                  }
                }}
                onEscapeKeydown={() => {
                  if (!loadingReject) {
                    mutateReject();
                  }
                }}
              >
                {/* <SpecialModalBackground> */}
                <Box
                  style={{
                    margin: '0 auto',
                    alignSelf: 'center',
                    borderRadius: '20px',
                    position: 'relative',
                    backgroundColor: 'white',
                    padding: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: '100vw',
                    maxWidth: '650px',
                  }}
                >
                  {!isActivateMode ? (
                    <Mutation
                      mutation={GENERATE_CODE}
                      onCompleted={(data) => {
                        if (data.getSmsLoginActivationOtp) {
                          if (data.getSmsLoginActivationOtp.reason === 'ALREADY_SENT') {
                            setIsActivateMode(true);
                            return;
                          }
                          if (!data.getSmsLoginActivationOtp.ok || data.getSmsLoginActivationOtp.reason) {
                            setErrors(convertErrorCodeToString(data.getSmsLoginActivationOtp.reason));
                            return;
                          }
                          setIsActivateMode(true);
                        }
                      }}
                    >
                      {(mutate, { loading, error }) => (
                        <Flex flexDirection={'column'}>
                          <Heading textAlign={'center'} fontSize={'20px'} fontWeight={600}>
                            Log In with a One-time code
                          </Heading>
                          <Text textAlign={'center'} fontSize={'16px'} mt={4}>
                            Moving forward, you’ll be able to use a one-time code sent to your phone to securely sign in.
                            <br />
                            Would you like to activate this feature?
                          </Text>

                          <Button
                            variant={'primary'}
                            disabled={loadingReject || loading}
                            mt={4}
                            alignSelf={'center'}
                            onClick={() => {
                              setErrors(null);
                              // history.push('/activate-sms-login')
                              mutate();
                            }}
                          >
                            Yes, activate the feature
                          </Button>
                          {errors && (
                            <Text style={{ color: '#ff6804ff' }} textAlign={'center'} mt={3}>
                              {errors}
                            </Text>
                          )}

                          <Text
                            style={{ cursor: 'pointer', color: '#046DFF', textDecoration: 'underline' }}
                            alignSelf={'center'}
                            mt={4}
                            onClick={() => {
                              if (!loadingReject) {
                                mutateReject();
                              }
                            }}
                            disabled={loadingReject}
                          >
                            Dismiss
                          </Text>
                        </Flex>
                      )}
                    </Mutation>
                  ) : (
                    <ActivateSmsLoginFeature
                      initialStepId={1}
                      onActivated={() => setShowComplete(true)}
                      onStepChanged={(step) => setCurrentStep(step)}
                      onClose={() => setIsOpen(false)}
                      reject={() => {
                        if (!loadingReject) {
                          mutateReject();
                        }
                      }}
                    />
                  )}
                </Box>
                {/* </SpecialModalBackground> */}
              </Modal>

              // <Container>
              //   <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#b3d3c6ff', borderRadius: '10px' }} mb={'32px'}>
              //     <Flex style={{ padding: '12px 8px' }}>
              //       <svg style={{ alignSelf: 'center' }} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              //         <path
              //           d="M37.288 8C37.0167 7.26706 36.5895 6.60174 36.036 6.05C33.968 4 30.644 4 24 4C17.356 4 14.03 4 11.964 6.05C11.4105 6.60174 10.9833 7.26706 10.712 8M10 36C10.174 38.84 10.652 40.646 11.964 41.95C14.03 44 17.354 44 24 44C30.646 44 33.97 44 36.034 41.95C37.348 40.646 37.826 38.838 38 36"
              //           stroke="#354E79"
              //           strokeWidth="1.5"
              //           strokeLinecap="round"
              //         />
              //         <path
              //           d="M12 20L16 24M16 20L12 24M22 20L26 24M26 20L22 24M32 20L36 24M36 20L32 24M34 14H14C10.228 14 8.344 14 7.172 15.172C6 16.344 6 18.228 6 22C6 25.772 6 27.656 7.172 28.828C8.344 30 10.228 30 14 30H34C37.772 30 39.656 30 40.828 28.828C42 27.656 42 25.772 42 22C42 18.228 42 16.344 40.828 15.172C39.656 14 37.772 14 34 14Z"
              //           stroke="#354E79"
              //           strokeWidth="1.5"
              //           strokeLinecap="round"
              //           strokeLinejoin="round"
              //         />
              //         <path d="M24 38V38.02" stroke="#354E79" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              //       </svg>

              //       <Flex style={{ overflow: 'hidden', padding: '8px 12px' }} flexDirection={'column'}>
              //         <Text fontSize={'14px'} fontWeight={500} mb={3} ml={2}>
              //           Sign in faster with SMS codes
              //         </Text>
              //         <Text fontSize={'14px'} ml={2} mb={4}>
              //           Skip typing your password on every login.
              //           <br />
              //           Enable SMS sign-in and receive a one-time code on your phone when you log in.
              //         </Text>

              //         <Mutation refetchQueries={[{ query: ADVERTISE_SMS_LOGIN }]} awaitRefetchQueries={true} mutation={REJECT_SMS_LOGIN}>
              //           {(mutate, { loading:loadingReject }) => (
              //             <Flex style={{ alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
              //               <Button
              //                 onClick={mutate}
              //                 disabled={loadingReject}
              //                 variant={'outline'}
              //                 style={{ padding: '2px 14px', fontSize: '13px', fontWeight: 400, width: 'fit-content', maxWidth: 'fit-content', flex: 'initial' }}
              //               >
              //                 Reject
              //               </Button>
              //               <Button
              //                 disabled={loadingReject}
              //                 variant={'primary'}
              //                 onClick={() => history.push('/activate-sms-login')}
              //                 style={{ padding: '2px 14px', fontSize: '13px', fontWeight: 400, width: 'fit-content', maxWidth: 'fit-content', flex: 'initial', border: '2px solid #344f79' }}
              //               >
              //                 Enable
              //               </Button>
              //             </Flex>
              //           )}
              //         </Mutation>
              //       </Flex>
              //     </Flex>
              //   </Card>
              // </Container>
            );
          }}
        </Query>
      )}
    </Mutation>
  );
});
